<span
  [class.post-quality-indicator-pill--large]="size === 'large'"
  [class.post-quality-indicator-pill--small]="size === 'small'"
  [ngbTooltip]="tooltipText"
  [style.border-color]="color"
  [style.color]="color"
  class="post-quality-indicator-pill"
  container="body"
  placement="top"
>
  <fa-icon [icon]="['fas', icon]" class="pill-icon"></fa-icon>
  <span class="pill-label">{{ label }}</span>
</span>
